import React from 'react';
import { Form } from '@tribeplatform/react-components/Form';
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { postListOrdersFactory } from '@tribeplatform/react-components/PostList';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { Select } from '@tribeplatform/react-ui-kit/Select';
import { useBlock } from '../../hooks/index.js';
const views = [
    { value: 'card', text: 'Card view' },
    { value: 'row', text: 'Row view' },
];
export const FeedBlockSettings = () => {
    const postListOrders = useStaticIntl(postListOrdersFactory);
    const { block: { props: { view, orderBy }, }, upsertProp, } = useBlock();
    return (React.createElement(Form, { onChange: e => {
            const target = e === null || e === void 0 ? void 0 : e.target;
            upsertProp(target.name, target.value);
        }, defaultValues: { view, orderBy } },
        React.createElement("div", { className: "flex flex-col space-y-5" },
            React.createElement(FormControl.Select, { name: "view", value: view, onChange: (value) => {
                    upsertProp('view', value);
                    return value;
                }, label: React.createElement(T, { id: "Blocks.Feed.DefaultViewStyle", defaultMessage: "Default view style" }) },
                React.createElement(Select.Button, null, views.find(v => v.value === view).text),
                React.createElement(Select.Items, null, views.map(view => (React.createElement(Select.Item, { key: view.value, value: view.value }, view.text))))),
            React.createElement(FormControl.Select, { name: "orderBy", value: orderBy, onChange: (value) => {
                    upsertProp('orderBy', value);
                    return value;
                }, label: React.createElement(T, { id: "Blocks.Feed.DefaultSorting", defaultMessage: "Default sorting" }) },
                React.createElement(Select.Button, null, postListOrders.find(o => o.value === orderBy).name),
                React.createElement(Select.Items, null, postListOrders.map(order => (React.createElement(Select.Item, { key: order.value, value: order.value }, order.name))))))));
};
//# sourceMappingURL=Settings.js.map